import axios from 'axios';
import {
  Status,
  MoneylineStatusResponse,
  MoneylineResponse,
  Configuration,
  MoneylineConfigurationResponse,
  MoneylineSuccessResponse,
  BooleanParameterName,
  NumberParameterName,
} from './moneyline.types';

export function parseMoneylineStatusResponse(
  data: MoneylineStatusResponse,
): Status {
  if (data.Services === undefined || !Array.isArray(data.Services)) {
    return { errors: {} };
  }

  return data.Services.reduce<Status>(
    (status, service) => {
      if (service.Status === 'OK') {
        status[service.Name] = true;
        status.errors[service.Name] = '';
      } else {
        status[service.Name] = false;
        status.errors[service.Name] = service.Message;
      }
      return status;
    },
    { errors: {} },
  );
}

export function parseMoneylineConfigurationResponse(
  data: MoneylineConfigurationResponse,
): Configuration {
  if (data.Parameters === undefined || !Array.isArray(data.Parameters)) {
    return {};
  }

  return data.Parameters.reduce<Configuration>((parameters, parameter) => {
    if (parameter.Name in BooleanParameterName) {
      parameters[parameter.Name as BooleanParameterName] =
        parameter.Value === 'True';
    }

    if (parameter.Name in NumberParameterName) {
      parameters[parameter.Name as NumberParameterName] = parseInt(
        parameter.Value,
        10,
      );
    }

    return parameters;
  }, {});
}

function isMoneylineResponseOk<T>(
  responseData: MoneylineResponse<T>,
): responseData is MoneylineSuccessResponse<T> {
  if ('Result' in responseData) {
    return responseData.Result === 'OK';
  }
  if ('State' in responseData) {
    return responseData.State === 'OK';
  }
  return responseData.ApiException === null;
}

export async function getMoneylineHttpWrapper<T>(
  url: string,
): Promise<MoneylineSuccessResponse<T>> {
  const response = await axios.get<MoneylineResponse<T>>(url, {
    headers: {
      Authorization: 'Basic dXNlcmFwaTptZHBhcGk=',
    },
  });

  if (!isMoneylineResponseOk(response.data)) {
    throw new Error(response.data.ApiException);
  }

  return response.data;
}

export async function postMoneylineHttpWrapper<T>(
  url: string,
  data: unknown,
): Promise<MoneylineSuccessResponse<T>> {
  const response = await axios.post<MoneylineResponse<T>>(url, data || null, {
    headers: {
      Authorization: 'Basic dXNlcmFwaTptZHBhcGk=',
    },
  });

  if (!isMoneylineResponseOk(response.data)) {
    throw new Error(response.data.ApiException);
  }

  return response.data;
}
